import CommonButton from "@components/CommonButton";
import UploadImage from "@components/UploadImage";
import { Trans } from "react-i18next";

export default function () {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <UploadImage name="a813bd97.png" className="w-[100px] h-[100px] object-contain" />
      <div className="text-[14px] font-normal text-kds-fg-subtle">
        <Trans>Currently in beta, more coming soon.</Trans>
      </div>
      <CommonButton type="primary" className="text-[16px] mt-[16px]">
        <Trans>Join the waitlis</Trans>
      </CommonButton>
    </div>
  );
}
